<template>
  <v-container class="py-6">
    <v-responsive max-width="700" class="mx-auto text-center">
      <h2 class="text-h3 text-lg-h2 mb-6">Reset Password</h2>
    </v-responsive>

    <v-card class="pa-4 mx-auto" max-width="600">
      <v-card-text>
        <v-text-field
          v-model="email"
          label="Email"
          outlined
        ></v-text-field>
       
        <!-- <v-text-field
          label="Password"
          v-model="password"
          v-bind:type="showPassword ? 'text' : 'password'"
          v-bind:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPassword = !showPassword"
          autocomplete="off"
          outlined
          hide-details
        ></v-text-field> -->

        <!-- <v-checkbox dense label="Remember me"></v-checkbox> -->
        <v-btn
          block
          class="secondary"
          :loading="this.loading"
          @click="reset"
          x-large
        >Reset Password</v-btn>

        <!-- <div class="text-center mt-3 text-body-2">
          <router-link to="/signup">Create new account.</router-link>
        </div>

        <div class="text-center mt-2 text-body-2">
          <router-link to="/reset_password">Forgot your password?</router-link>
        </div> -->

      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { getAuth, sendPasswordResetEmail } from "firebase/auth";

export default {
  name: 'ResetPassword',

  data: () => ({
    // showPassword: false,
    email: '',
    // password: '',
    loading: false,
    // subscription: false,
    // is_premier: false,
  }),

  methods: {
    reset() {
      this.loading = true

      var actionCodeSettings = {
        url: `${process.env.VUE_APP_API_ORIGIN}/#/`,
      };

      const auth = getAuth();
      sendPasswordResetEmail(auth, this.email, actionCodeSettings)
      .then(() => {
        // Password reset email sent!
        // ..
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        // ..
      });
    }
  }
};
</script>